(() => {
  let loading = false;

  async function loadMore(button) {
    if (loading || !button || !button.href) return;

    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    loading = true;
    const originalText = button.textContent;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'LOADING...';

    try {
      const response = await fetch(button.href, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('#product-grid');

      if (!newGrid) throw new Error('No product grid found on next page');

      const fragment = document.createDocumentFragment();
      newGrid.querySelectorAll(':scope > .grid__item').forEach((item) => fragment.appendChild(item));
      grid.appendChild(fragment);

      const nextButton = doc.querySelector('[data-collection-load-more]');
      const wrapper = button.closest('.collection-load-more');

      if (nextButton && nextButton.href) {
        button.href = nextButton.href;
        button.textContent = 'LOAD MORE';
        button.removeAttribute('aria-busy');
      } else if (wrapper) {
        wrapper.remove();
      }
    } catch (error) {
      console.error('Load more products error:', error);
      button.textContent = originalText || 'LOAD MORE';
      button.removeAttribute('aria-busy');
    } finally {
      loading = false;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-collection-load-more]');
    if (!button) return;

    event.preventDefault();
    loadMore(button);
  });
})();